import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { UserContext, UserContextProvider } from './components/UserContext';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
//import stylesheets
//import 'bootstrap/dist/css/bootstrap.min.css';

const themes={
  //dark:'https://unpkg.com/@progress/kendo-theme-default@10.0.0/dist/default-main-dark.css',
  //light:'https://unpkg.com/@progress/kendo-theme-default@10.0.0/dist/default-main.css'
  //dark:'https://unpkg.com/@progress/kendo-theme-bootstrap@13.1.1/dist/bootstrap-main-dark.css',
  dark:'https://unpkg.com/@progress/kendo-theme-bootstrap@14.1.0/dist/bootstrap-main-dark.css',
  light:'https://unpkg.com/@progress/kendo-theme-bootstrap@14.1.0/dist/bootstrap-main.css'
  //light:'https://unpkg.com/@progress/kendo-theme-bootstrap@13.1.1/dist/bootstrap-main.css'
  
}


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  //<React.StrictMode>
  <ThemeSwitcherProvider
    themeMap={themes}
    insertionPoint="inject-styles-here"
  >
    <UserContextProvider>
      <App />
    </UserContextProvider>
  </ThemeSwitcherProvider> 
  //</React.StrictMode>
);